// frontend/src/pages/LandingPage.js
import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import Footer from '../components/Footer';
import logo from '../assets/icons/iconoGestionEJP.png';
import { useAuth } from '../auth/AuthContext';

const LandingPage = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const [seccionActiva, setSeccionActiva] = useState(location.state?.seccion || 'inicio');
    const navigate = useNavigate();

    if (isAuthenticated) return <Navigate to="/home" replace />;

    const tabs = [
        { id: 'inicio', label: 'Inicio', icon: 'bi-house-door' },
        { id: 'nosotros', label: 'Sobre Nosotros', icon: 'bi-info-circle' },
    ];

    const renderInicio = () => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '2rem 1rem', flex: 1 }}>
            <img src={logo} alt="Logo GestiónEJP" style={{ width: 'min(300px, 80vw)', height: 'auto', marginBottom: '2rem', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.1))' }} />
            <h2 style={{ fontSize: 'clamp(0.95rem, 2.5vw, 1.15rem)', fontWeight: 500, color: '#475569', marginBottom: '1.5rem', lineHeight: 1.6 }}>
                Sistema integral de gestión de trámites previsionales
                <br />del Estudio Jurídico Previsional - Dr. Gabriel Mongi
            </h2>
            <div className="landing-inicio-grid">
                {[
                    { icon: '🏢', label: 'Estudio Jurídico', sub: 'Córdoba, Argentina' },
                    { icon: '👥', label: 'Uso Interno', sub: 'Personal autorizado' },
                    { icon: '🔐', label: 'Datos Protegidos', sub: 'Ley 25.326' },
                ].map((item, i) => (
                    <div key={i} style={{ padding: '1.25rem 1rem', borderRadius: '12px', background: '#f8fafc', border: '1px solid #e2e8f0', transition: 'all 0.2s' }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(37,99,235,0.1)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                        <div style={{ fontSize: '1.75rem', marginBottom: '0.4rem' }}>{item.icon}</div>
                        <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.9rem' }}>{item.label}</div>
                        <div style={{ color: '#64748b', fontSize: '0.8rem' }}>{item.sub}</div>
                    </div>
                ))}
            </div>
            <div style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                <button onClick={() => navigate('/login')} className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ boxShadow: 'var(--shadow-md)' }}>
                    <i className="bi bi-box-arrow-in-right"></i> Acceder al Sistema
                </button>
                <button onClick={() => setSeccionActiva('nosotros')} className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold">
                    <i className="bi bi-info-circle"></i> Conocer más
                </button>
            </div>
        </div>
    );

    const renderNosotros = () => (
        <div style={{ padding: '2rem 1rem', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ maxWidth: '800px', width: '100%' }}>
                <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                    <h2 style={{ fontSize: 'clamp(1.4rem, 4vw, 2rem)', fontWeight: 800, color: '#0f172a', marginBottom: '0.75rem' }}>¿Qué es GestiónEJP?</h2>
                    <div style={{ width: '50px', height: '4px', background: '#3b82f6', borderRadius: '2px', margin: '0 auto' }} />
                </div>
                <div style={{ background: 'white', borderRadius: '16px', padding: '2rem', border: '1px solid #e2e8f0', boxShadow: 'var(--shadow-md)', marginBottom: '2rem' }}>
                    <p style={{ color: '#475569', fontSize: '1rem', lineHeight: 1.8, marginBottom: '1.5rem' }}>
                        GestiónEJP es la plataforma tecnológica del <strong>Estudio Jurídico Previsional - Dr. Gabriel Mongi</strong>, diseñada para optimizar la gestión diaria de trámites previsionales.
                    </p>
                    <p style={{ color: '#475569', fontSize: '1rem', lineHeight: 1.8, margin: 0 }}>
                        La plataforma centraliza toda la información de clientes y trámites en un único lugar seguro y accesible para el personal autorizado del estudio.
                    </p>
                </div>
                <div className="landing-nosotros-grid">
                    {[
                        { icon: 'bi-building', title: 'Estudio Profesional', desc: 'Con sede en Córdoba, Argentina, especializado en derecho previsional y jubilatorio.' },
                        { icon: 'bi-person-check', title: 'Acceso Controlado', desc: 'Solo personal autorizado puede acceder. Cada cuenta es validada por un administrador.' },
                        { icon: 'bi-shield-check', title: 'Protección de Datos', desc: 'Cumplimos con la Ley 25.326. Datos cifrados, backups automáticos y auditoría.' },
                    ].map((item, i) => (
                        <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0', transition: 'all 0.2s' }}
                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 20px rgba(37,99,235,0.08)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                            <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: 'var(--gradient-primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '0.75rem' }}>
                                <i className={`bi ${item.icon}`} style={{ fontSize: '1.2rem', color: '#2563eb' }}></i>
                            </div>
                            <h4 style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e293b', marginBottom: '0.4rem' }}>{item.title}</h4>
                            <p style={{ color: '#64748b', fontSize: '0.85rem', lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
                        </div>
                    ))}
                </div>
                <div style={{ textAlign: 'center', marginTop: '2.5rem', paddingBottom: '1rem' }}>
                    <button onClick={() => navigate('/login')} className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold mx-auto" style={{ boxShadow: 'var(--shadow-md)' }}>
                        <i className="bi bi-box-arrow-in-right"></i> Acceder al Sistema
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <style>{`
                .landing-nav-tabs { position: absolute; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 0.25rem; }
                .landing-nav-title { display: inline; }
                .landing-nav-login-text { display: inline; }
                .landing-nav-login-icon { display: none; }
                .landing-inicio-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; width: 100%; max-width: 600px; }
                .landing-nosotros-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; }
                @media (max-width: 640px) {
                    .landing-nav-tabs { position: static; transform: none; left: auto; }
                    .landing-nav-title { display: none; }
                    .landing-nav-mobile-title { display: inline !important; }
                    .landing-nav-login-text { display: none; }
                    .landing-nav-login-icon { display: inline; }
                    .landing-nav { padding: 0 0.75rem !important; gap: 0.25rem; }
                    .landing-nav-home { font-size: 1rem !important; }
                    .landing-nav-tab { padding: 0.5rem 0.5rem !important; font-size: 0.8rem !important; gap: 0.25rem !important; }
                    .landing-nav-login { padding: 0.45rem 0.7rem !important; }
                    .landing-inicio-grid { grid-template-columns: repeat(2, 1fr); max-width: 100%; }
                    .landing-nosotros-grid { grid-template-columns: 1fr; }
                }
                @media (max-width: 400px) {
                    .landing-inicio-grid { grid-template-columns: 1fr; }
                }
            `}</style>

            <nav className="landing-nav" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1100, height: '70px', background: 'var(--primary)', boxShadow: 'var(--shadow-md)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1.5rem' }}>
                <button className="landing-nav-home" onClick={() => setSeccionActiva('inicio')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white', fontWeight: 600, fontSize: '1.15rem', fontFamily: "'Inter','Segoe UI',sans-serif", display: 'flex', alignItems: 'center', gap: '0.6rem', padding: 0, flexShrink: 0 }}>
                    <span className="landing-nav-title">Estudio Jurídico Previsional</span>
                    <span className="landing-nav-mobile-title" style={{ display: 'none' }}>GestiónEJP</span>
                </button>
                <div className="landing-nav-tabs">
                    {tabs.map((tab) => (
                        <button key={tab.id} className="landing-nav-tab" onClick={() => setSeccionActiva(tab.id)} style={{ background: 'none', border: 'none', borderBottom: seccionActiva === tab.id ? '2px solid white' : '2px solid transparent', padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: seccionActiva === tab.id ? 700 : 400, color: seccionActiva === tab.id ? 'white' : 'rgba(255,255,255,0.75)', cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px' }}
                            onMouseEnter={(e) => { if (seccionActiva !== tab.id) e.currentTarget.style.color = 'white'; }}
                            onMouseLeave={(e) => { if (seccionActiva !== tab.id) e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}>
                            <i className={`bi ${tab.icon}`}></i> {tab.label}
                        </button>
                    ))}
                </div>
                <button className="landing-nav-login" onClick={() => navigate('/login')} style={{ background: 'rgba(255,255,255,0.15)', border: '1.5px solid rgba(255,255,255,0.6)', borderRadius: '8px', padding: '0.45rem 1.1rem', color: 'white', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}>
                    <i className="bi bi-box-arrow-in-right landing-nav-login-icon"></i>
                    <span className="landing-nav-login-text">Iniciar Sesión</span>
                </button>
            </nav>

            <div style={{ flex: 1, background: 'var(--bg-page)', display: 'flex', flexDirection: 'column', paddingTop: '70px', paddingBottom: '2rem' }}>
                {seccionActiva === 'inicio' ? renderInicio() : renderNosotros()}
            </div>

            <Footer />
        </div>
    );
};

export default LandingPage;

